import React from 'react';

const FinishTick = () => {
  return (
    <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M60 14.2c25.252 0 45.8 20.548 45.8 45.8S85.252 105.8 60 105.8 14.2 85.252 14.2 60 34.748 14.2 60 14.2z'
        stroke='#000'
        stroke-width='4.4'
      />
      <path d='M37 57.267 54.837 75 83 47' stroke='var(--theme-primary, #810ea9)' strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default FinishTick;
